
<script setup>
  import { ref, onBeforeMount, computed } from "vue";
  import { useUiStore } from "@/stores/ui";

  const emit = defineEmits(["removeBackground"]);
  const uiStore = useUiStore();
  const getModalInfo = computed(()=> uiStore.modalData);
  const getModalAction = computed(()=> uiStore.modalAction);

  let name = ref(null);
  let deviceToken = ref(null);
  let copyText = ref('Copy to clipboard');

  const copyToClipboard = () => {
    navigator.clipboard.writeText(deviceToken.value);
    copyText.value = 'Copied!';
    setTimeout(()=>{
        copyText.value = 'Copy to clipboard';
    },1000)
  }

  onBeforeMount(() => {
    if(getModalInfo.value && getModalInfo.value.data_type == 'device' && getModalAction.value == 'device_token'){
        name.value = getModalInfo.value.name;
        deviceToken.value = getModalInfo.value.token;
    }
  });

  const resetStoreData = () =>{
    emit('removeBackground');
    uiStore.setModalState(false);
    uiStore.setModalData({});
    uiStore.setModalAction(null);
  };
</script>

<template>
  <DModal v-if="getModalAction === 'device_token'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> {{name}} Token </template>
    <template #body>
    
        <div class="w-full text-center padding-none flex items-center">
            <div class="w-full padding-none" @click="copyToClipboard">
            <div  class="text-center" title="Copy to clipboard">
                <span class="generated-token">{{ deviceToken }}</span>
            </div>
            <span class="click-message" v-text="copyText"></span>
            </div>
        </div>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex justify-center">
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
        </div>
      </div>
    </template>
  </DModal>
</template>